export default "__VITE_ASSET__pblKRx52__"